import React from 'react';
import { Button, ButtonProps } from 'antd';
import styled from 'styled-components';

const CustomButton = styled(Button)`
  width: 100%
`;

const ButtonFull: React.FC<ButtonProps> = ({...rest}) => {
  return (
    <CustomButton {...rest} ></CustomButton>
  );
};

export default ButtonFull;